import { fetchOrganizationOptionsCount } from '@/api/v4/organization.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import type { OrganizationOption as APIOrganizationOption } from '@/api/v4/organization.api';
import type { CompanyOption } from '@/types';

export const useCountCompanyOptions = (projectId?: string) => {
  const getCompanyOptions = async () =>
    await fetchOrganizationOptionsCount({
      ...(projectId && { projectId }),
    });

  return useQuery({
    queryKey: [QueryKey.CompanyOptionsCount, projectId],
    queryFn: getCompanyOptions,
    staleTime: 1000 * 10 * 5,
  });
};

export const mapOrganizationOptions = (
  organizations: APIOrganizationOption[],
): CompanyOption[] =>
  organizations.map(organization => ({
    label: organization.name,
    value: organization.id,
    logo: organization.logoUrl,
    domain: organization.domain,
  }));
